var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"headers":_vm.headers,"fields":_vm.fields,"items":_vm.residents,"viewAction":'refresh-resident-dashboard',"title":"Move-Out Alerts","subTitle":"These residents have reached or passed their move-out date but have not been moved out. Please take action.","hideSearch":"true"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcb3e90e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/property/dashboard/MoveOutAlerts.vue
// module id = oKAq
// module chunks = 0 1